import React, {useCallback, useEffect} from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import AddQuestionModal from "./AddQuestionModal";
import useConstructor from "./useConstructor";
import AddButton from "../../../../../../ui/AddButton";
import QuestionList from "./QuestionList";
import {QuestionAnswer} from "@material-ui/icons";
import {getQuestions} from "../../../../store/actions";
import {connect} from "react-redux";
import DialogTitle from "../../../../../../ui/Dialog/DialogTitle";

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  }
});

const Constructor = ({ disabled, questions, getQuestions, quizId , classes, editmode }) => {
  const [addModalOpen, setAddModalOpen] = React.useState(false);
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [editableId, setEditableId] = React.useState(null);
  const [editableItem, setEditableItem] = React.useState(null);
  const {
    createQuestion,
    deleteQuestion,
    updateQuestion,
    isCreatingQuestion,
    isDeletingQuestion,
    isUpdatingQuestion
  } = useConstructor();

  useEffect(() => {
    if (editableId) {
      let item = questions.find(item => item.id === editableId);
      setEditableItem(item);
      setEditModalOpen(true);
      //console.log(item);
    } else {
      setEditableItem(null);
    }
  }, [questions, editableId]);

  useEffect(() => {
    getQuestions(quizId);
  }, [quizId]);

  const showAddModal = () => {
    setAddModalOpen(true);
  };

  const closeAddModal = () => {
    setAddModalOpen(false);
  }

  const closeEditModal = () => {
    setEditModalOpen(false);
  }

  const createQuestionChain = useCallback((form) => {
    return createQuestion(quizId, form)
      .then(() => {
        closeAddModal();
        getQuestions(quizId);
      }, () => {
        closeAddModal();
      })
  }, [addModalOpen, createQuestion, setAddModalOpen]);

  const updateQuestionChain = useCallback((form) => {
    if (editableId) {
      return updateQuestion(editableId, form)
        .then(() => {
          setEditableItem(null);
          setEditableId(null);
          closeEditModal();
        }, () => {
          closeEditModal();
        }).finally(() => {
          getQuestions(quizId);
        })
    }
  }, [editModalOpen, updateQuestion, setEditModalOpen]);

  const deleteQuestionChain = useCallback((questionId) => {
    return deleteQuestion(questionId)
      .then(() => {
        getQuestions(quizId);
      }, (reason) => {
        console.log(reason);
      })
  }, [deleteQuestion]);

  return (
    <div className={classes.root}>
      <AddQuestionModal
        title="Добавить вопрос"
        confirmButtonCaption="Добавить"
        isCreating={isCreatingQuestion}
        open={addModalOpen}
        handleClose={closeAddModal}
        onCreate={createQuestionChain}/>
      <AddQuestionModal
        title="Редактировать вопрос"
        confirmButtonCaption="Сохранить"
        isCreating={isUpdatingQuestion}
        open={editModalOpen}
        questionData={editableItem}
        handleClose={closeEditModal}
        onCreate={updateQuestionChain}/>
      <div className={classes.heading}>
        Заполнение опроса
        <div style={{"marginLeft":16}}>
          <AddButton onClick={showAddModal}/>
        </div>
      </div>
      <QuestionList questions={questions}
                    deleteQuestion={deleteQuestionChain}
                    editQuestion={(qId) => {
                      setEditableId(qId);
                    }}/>
    </div>
  );
};

const mapStateToProps = state => ({
  questions: state.manageQuiz.questions
});

const mapDispatchToProps = dispatch => ({
  getQuestions: id => dispatch(getQuestions(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Constructor));
